import { useEffect, useState } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import { Button } from "primereact/button";
import FormContainer from "../../form/FormContainer";
import { authorisedRepresentativeModalInvite } from "../../../shared/formObjects/application/authorisedRepresentativeModalInvite";
import { Dialog } from "primereact/dialog";
import ComponentHeader from "../../componentHeader/componentHeader";
import userLinkListTable from "../../../shared/tableObjects/userLinkListTable";
import FrontEndTable from "../../table/FrontEndTable";
import { useGlobalContext } from "../../../shared/GlobalContext";

function AuthorisedRepresentativeComponent() {
  const { fetchData } = useApiClient("UserManagement", { identity: true });
  const linkApi = useApiClient("UserLink", { identity: true });
  const [visible, setVisible] = useState<boolean>();
  const {
    application: { hasAppeal },
    id,
  } = useApplicationContext();
  const [users, setUsers] = useState<any[]>([]);
  const [refresh, setRefresh] = useState<boolean>(false);
  const { addNavItem, accountInfo } = useGlobalContext();

  useEffect(() => {
    fetchData(`getInvitedUsers/${id}`, { discriminator: 0 }).then((res: any) => {
      setUsers(res.data);
    });
  }, [refresh]);

  useEffect(() => {
    addNavItem({
      label: "Authorised Representative Management",
      id: "AuthorisedRepresentativeManagement",
    });
  }, []);

  return (
    <>
      <div className="flex flex-column align-items-start w-full p-5 pl-container" id="AuthorisedRepresentativeManagement">
        <ComponentHeader label={"Authorised Representative Management"} />
        <div>
          <div className="flex flex-column">
            {accountInfo.isManager && !hasAppeal && (
              <Button
                tooltip="Invite User to Application"
                className="invite-button mt-2 mb-3"
                label="Invite User"
                onClick={() => {
                  setVisible(true);
                }}></Button>
            )}
          </div>
          <Dialog
            header="Invite User"
            visible={visible}
            style={{ width: "50vw" }}
            className="z-top modal-styles invite-user"
            onHide={() => setVisible(false)}>
            <FormContainer
              formBody={authorisedRepresentativeModalInvite}
              apiClient={linkApi}
              disabled={false}
              showInternalNotes={false}
              id={id}
              hideCancelButton={true}
              saveSuccessCB={() => {
                setRefresh(true);
                setVisible(false);
              }}
              saveErrorCB={() => {
                setVisible(false);
              }}
            />
          </Dialog>
          <div className="sectionHeaderTable">
            <span>Authorised Representative</span>
          </div>
          <FrontEndTable data={users} columns={userLinkListTable(accountInfo.isManager)} header="" />
        </div>
      </div>
    </>
  );
}

export default AuthorisedRepresentativeComponent;
